import { connect } from 'react-redux';
import Pending from '../components/Pending.js';

const mapStateToProps = (state) => {
    return {}
}

const mapDispatchToProps = (dispatch) => {
    return {}
}

export default connect(mapStateToProps, mapDispatchToProps)(Pending);



/** WEBPACK FOOTER **
 ** ./src/containers/PendingContainer.js
 **/